import React from 'react';
import { LucideIcon } from 'lucide-react';

type ColorType = 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'cyan';

interface StatsCardProps {
  title: string;
  value: React.ReactNode;
  subtitle?: string;
  icon: LucideIcon;
  color?: ColorType;
}

const StatsCard: React.FC<StatsCardProps> = ({ 
  title, 
  value, 
  subtitle, 
  icon: Icon, 
  color = 'blue' 
}) => {
  const colorClasses = {
    blue: {
      bg: 'bg-blue-100',
      icon: 'text-blue-600',
      subtitle: 'text-green-600'
    },
    green: {
      bg: 'bg-green-100',
      icon: 'text-green-600',
      subtitle: 'text-green-600'
    },
    yellow: {
      bg: 'bg-yellow-100',
      icon: 'text-yellow-600',
      subtitle: 'text-green-600'
    },
    red: {
      bg: 'bg-red-100',
      icon: 'text-red-600',
      subtitle: 'text-gray-500'
    },
    purple: {
      bg: 'bg-purple-100',
      icon: 'text-purple-600',
      subtitle: 'text-green-600'
    },
    cyan: {
      bg: 'bg-cyan-100',
      icon: 'text-cyan-600',
      subtitle: 'text-green-600'
    }
  } as const;

  const currentColor = colorClasses[color];

  return (
    <div className="card">
      <div className="card-body">
        <div className="flex items-center">
          <div className={`p-2 ${currentColor.bg} rounded-apple`}>
            <Icon className={`w-5 h-5 ${currentColor.icon}`} />
          </div>
          <div className="ml-3">
            <p className="text-sm font-medium text-gray-600">{title}</p>
            <p className="text-lg font-semibold text-gray-900">{value}</p>
            {subtitle && (
              <p className={`text-xs ${currentColor.subtitle}`}>
                {subtitle}
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCard;
